import {
    GET_RENTALS,
    GET_RENTALS_SUCCESS,
    GET_RENTALS_FAILURE,
    GET_RENTAL_PROPERTIES,
    GET_RENTAL_PROPERTIES_SUCCESS,
    GET_RENTAL_PROPERTIES_FAILURE,
    SET_RENTAL_FILTERS,
    RESET_RENTAL_FILTERS
} from '../actions/types';

const INITIAL_FILTERS = { propertyId: '', status: '', from: null, to: null };

const INITIAL_STATE = {
    rentals: [], // already scoped to managed_property_ids by the saga
    loading: false,
    error: null,

    propertyOptions: [],
    propertyOptionsLoading: false,
    propertyOptionsError: null,

    filters: INITIAL_FILTERS
};

const toMillis = timestamp =>
    typeof timestamp?.seconds === 'number' ? timestamp.seconds * 1000 : null;

// Pure derivation of the visible rows from raw state — property/status/date filters,
// client-side over data the saga already loaded (no network/database call happens
// here). Exported so the page component can pull it in with a plain useMemo instead of
// carrying the matching logic itself.
export const filterRentals = (rentals, filters = INITIAL_FILTERS) => {
    return (rentals || []).filter(rental => {
        if (filters.propertyId && rental.property_id !== filters.propertyId) {
            return false;
        }
        if (filters.status && rental.status !== filters.status) {
            return false;
        }

        if (filters.from) {
            const startMs = toMillis(rental.start_date);
            if (startMs === null || startMs < new Date(filters.from).getTime()) {
                return false;
            }
        }
        if (filters.to) {
            const endMs = toMillis(rental.end_date);
            if (endMs === null || endMs > new Date(filters.to).getTime()) {
                return false;
            }
        }

        return true;
    });
};

const rentalsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_RENTALS:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_RENTALS_SUCCESS:
            return {
                ...state,
                loading: false,
                rentals: action.payload
            };
        case GET_RENTALS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case GET_RENTAL_PROPERTIES:
            return {
                ...state,
                propertyOptionsLoading: true,
                propertyOptionsError: null
            };
        case GET_RENTAL_PROPERTIES_SUCCESS:
            return {
                ...state,
                propertyOptionsLoading: false,
                propertyOptions: action.payload
            };
        case GET_RENTAL_PROPERTIES_FAILURE:
            return {
                ...state,
                propertyOptionsLoading: false,
                propertyOptionsError: action.payload
            };

        case SET_RENTAL_FILTERS:
            return {
                ...state,
                filters: action.payload
            };
        case RESET_RENTAL_FILTERS:
            return {
                ...state,
                filters: INITIAL_FILTERS
            };

        default:
            return state;
    }
};

export default rentalsReducer;
